var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"com-nav-home",on:{"click":_vm.nav_home_page}},[_c('i',{staticClass:"el-icon-top"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }